<ion-row>
    <ion-col size="12" class="padding-xxs center-text">
        <span class="bold text-color-element" [ngClass]="class">{{text}}
        </span>
    </ion-col>
</ion-row>